import { computed, Injectable, signal, WritableSignal } from '@angular/core';
import { EmploymentGridItemObject } from '@libs/types/src/user/object-type/employment-grid.object';
import { OrganizationGridItemObject, ServiceGridItemObject } from '@it2go/types';
import { dateifyOrNow } from '../../../../shared/helpers/date.helper';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { globalStore } from '../../../../shared/shared.global-service';
import { selectOrganizations } from '../../../../../store/global/global.selectors';

@Injectable()
export class UserEmploymentInfoStore extends ComponentStoreV2Factory {

    public services = computed<ServiceGridItemObject[]>(() => this.data.getServices()?.items || []);
    public employmentItems = computed<EmploymentGridItemObject[]>(() => this.data.getEmployments()?.items || []);
    public organizations: WritableSignal<OrganizationGridItemObject[]> = signal([]);

    public uniqueServices = computed(() => {
        const employments = this.employmentItems();
        const map: Record<number, Date> = {};
        employments.forEach(emp => {
            const currentDate = dateifyOrNow(emp.dateFrom);
            if (!map[emp.serviceId] || currentDate < map[emp.serviceId]) {
                map[emp.serviceId] = currentDate;
            }
        });
        return {
            items: Object.entries(map).map(([id, earliestDate]) => ({ name: this.getServiceName(id), earliestDate })),
        };
    });

    public uniqueOrganizations = computed(() => {
        const employments = this.employmentItems();
        const map: Record<number, Date> = {};
        employments.forEach(emp => {
            const currentDate = dateifyOrNow(emp.dateFrom);
            if (!map[emp.organizationId] || currentDate < map[emp.organizationId]) {
                map[emp.organizationId] = currentDate;
            }
        });
        return {
            items: Object.entries(map).map(([id, earliestDate]) => ({ name: this.getOrgName(id), earliestDate })),
        };
    });


    constructor() {
        super();
        this.subs.push(
            globalStore!.select(selectOrganizations).subscribe(
                orgs => this.organizations.set(orgs),
            ),
        );
    }

    private getServiceName(id: string): string {
        return this.globalGlobalStore.organizationStore.allServices().find(s => s.id === Number(id))?.name || '';
    }

    private getOrgName(id: string): string {
        return this.organizations().find(s => s.id === Number(id))?.name || '';
    }

}
